<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiClockOutline } from "@mdi/js";
export default {
  name: "MdiClockOutline",
  data() {
    return {
      svgPath: mdiClockOutline,
    };
  },
};
</script>
